import component from './component-resolver'

export default [
  {
    path: '/',
    name: 'home',
    component: component('Start')
  },
  {
    path: '/self',
    component: component('Entry'),
    children: [
      {
        name: 'chooseCategory',
        path: 'choose-category',
        component: component('self/ChooseCategory')
      },
      {
        name: 'chooseTemplate',
        path: 'choose-template',
        component: component('self/ChooseTemplate')
      },
      {
        name: 'selfSignUp',
        path: 'sign-up',
        component: component('self/SignUp')
      }
    ]
  },
  {
    path: '/help',
    name: 'Home',
    component: component('Entry'),
    children: [
      {
        name: 'websiteEnquiry',
        path: 'website',
        component: component('help/WebsiteEnquery')
      },
      {
        name: 'choosePackage',
        path: 'choose-package',
        component: component('help/ChoosePackage')
      },
      {
        name: 'helpSummary',
        path: 'summary',
        component: component('help/Summary')
      },
      {
        name: 'helpSignUp',
        path: 'sign-up',
        component: component('help/SignUp')
      },
      {
        name: 'helpConfirmation',
        path: 'thank-you',
        component: component('help/Confirmation')
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js